export const init = (survey: any) => {
  const barcodeScanner = {
    name: 'barcodescanner',
    title: 'Barcode Scanner',
    iconName: '',
    widgetIsLoaded: () => true,
    isFit: (question) => question.getType() === 'barcodescanner',

    activatedByChanged: (activatedBy) => {
      survey.JsonObject.metaData.addClass('barcodescanner', [], null, 'text');
      survey.JsonObject.metaData.addProperties('barcodescanner', [
        { name: 'scanButtonText', default: 'Scan' },
        { name: 'canEnterManually:boolean', default: 1 },
        {
          name: 'formats',
          default: 'RSS_EXPANDED ,CODE_128,CODE_93,CODE_39,QR_CODE,DATA_MATRIX,UPC_A,UPC_E,EAN_8,EAN_13,CODABAR,ITF,RSS14,RSS_EXPANDED' },
      ]);
    },
    isDefaultRender: false,
    htmlTemplate: `<div><input/>
      <input type="button" class="sv-btn sv-paneldynamic__add-btn sv-paneldynamic__add-btn--list-mode" style="margin-top: 0;" value="Scan">
      </div>`,
    afterRender: (question, el) => {
      const text = el.getElementsByTagName('input')[0];
      text.inputType = question.inputType;
      text.placeholder = question.placeHolder;
      const scanButton = el.getElementsByTagName('input')[1];
      scanButton.value = question.scanButtonText;
      scanButton.onclick = () => {
        alert('not available on portal')
      };

      text.setAttribute('disabled', 'disabled');
      if (question.canEnterManually) {
        text.removeAttribute('disabled');
      }
      text.onchange = () => {
        question.value = text.value;
      };
      const onValueChangedCallback = () => {
        text.value = question.value ? question.value : '';
      };
      const onReadOnlyChangedCallback = () => {
        if (question.isReadOnly) {
          text.setAttribute('disabled', 'disabled');
          scanButton.setAttribute('disabled', 'disabled');
        } else {
          if (question.canEnterManually) {
            text.removeAttribute('disabled');
          }
          scanButton.removeAttribute('disabled');
        }
      };
      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      question.valueChangedCallback = onValueChangedCallback;
      onValueChangedCallback();
      onReadOnlyChangedCallback();
    },
    willUnmount: (question, el) => {
    },
  };
  survey.CustomWidgetCollection.Instance.addCustomWidget(barcodeScanner, 'customtype');
};
